export default __webpack_public_path__ + "static/media/Philanthropy1.4fca7d7b.png";